import React from 'react';

import { useUserInfo } from '../../../../../helpers/hooks/useUserInfo';
import { AppStoreButtons } from '../../../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';

import { HamburgerDropdownToggle } from './components/HamburgerDropdownToggle';
import { LogOutButton } from './components/LogOutButton';
import { PrimaryDropDownLinks } from './components/PrimaryDropDownLinks';
import { SecondaryDropDownLinks } from './components/SecondaryDropDownLinks';
import { UserDetailsSection } from './components/UserDetailsSection';
import { useOnClickOutside } from '../../../../../helpers/hooks/useOnClickOutside';
import { LoginButton } from '../LoginButton/LoginButton';
import { trackEvent } from '../../../../../helpers/analytics/trackEvent';
import { useAnalytics } from '../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { SuspendedLoginButton } from '../LoginButton/SuspendedLoginButton';

interface IProps {
  expanded: boolean;
  onExpandedChange: (value: boolean) => void;
  isAppRouter?: boolean;
}

export const DropDownMenu = ({ expanded, onExpandedChange, isAppRouter = false }: IProps) => {
  const { isLoggedIn, user } = useUserInfo();
  const { currentPage } = useAnalytics();
  const mobileMenuRef = React.useRef<HTMLDivElement>(null);
  useOnClickOutside(mobileMenuRef, () => (expanded ? onExpandedChange(false) : null));

  return (
    <div ref={mobileMenuRef} className="main-navigation-child">
      <HamburgerDropdownToggle expanded={expanded} onExpandedChange={onExpandedChange} />
      <div
        className={`divide-midnight bg-sea-foam md:border-twilight absolute top-[40px] -right-6 h-screen max-h-[calc(100vh-var(--main-navigation-height-mobile))] w-screen origin-top-right divide-y overflow-y-auto py-0 transition-all md:top-[53px] md:-right-2 md:h-auto md:w-80 md:rounded-b-lg md:border-x md:border-b md:py-6 ${expanded ? `z-nav visible scale-100 opacity-100` : 'z-0 hidden scale-[0.98] opacity-0'}`}
        data-testid="dropdown-child-elements"
      >
        <div className="m-0">
          {!isLoggedIn && (
            <div className="px-6 pt-2 pb-6 sm:px-11 md:hidden" data-testid="TopCTAs">
              <div className="flex items-center justify-between sm:justify-start">
                {isAppRouter ? (
                  <SuspendedLoginButton
                    fallbackClassName="w-full"
                    className="mr-3 w-full rounded-lg text-base md:hidden"
                    id="DropDownMenuLoginButton"
                  />
                ) : (
                  <LoginButton
                    buttonSize="default"
                    onClick={() => {
                      void trackEvent({
                        name: 'mykiss_hamburger_clicked',
                        properties: { action: 'navigate', source: currentPage },
                      });
                    }}
                    className="mr-3 w-full rounded-lg text-base md:hidden"
                  />
                )}
              </div>
            </div>
          )}

          {!!user && <UserDetailsSection onExpandedChange={onExpandedChange} />}

          <PrimaryDropDownLinks onExpandedChange={onExpandedChange} />

          <SecondaryDropDownLinks onExpandedChange={onExpandedChange} />

          {isLoggedIn && <LogOutButton onExpandedChange={onExpandedChange} />}

          <AppStoreButtons
            className="my-4 ml-6 flex items-start sm:my-6 sm:ml-11 md:hidden"
            orientation="vertical"
            source="DropDownMenu"
          />
        </div>
      </div>
    </div>
  );
};
